import CollectionInterface from '@/utilities/bid/cost/Interfaces/CollectionInterface'
import ItemInterface from '@/utilities/bid/cost/Containers/Interfaces/ItemInterface'
import WorkCodeInterface from '@/utilities/bid/cost/Containers/Interfaces/WorkCodeInterface'

class ItemContainer {
  item: ItemInterface
  workCode: WorkCodeInterface
  poundInPence: number = 100
  constructor(item: ItemInterface, workCode: WorkCodeInterface) {
    this.item = item
    this.workCode = workCode
  }

  record(): CollectionInterface {
    return {
      key: this.workCode.slugName,
      workcode: this.workCode.id,
      title: this.workCode.description,
      calculated: this.item.calculated,
      rate: this.workCode.cost / this.poundInPence,
      manual: 0,
      total: (this.item.calculated * this.workCode.cost) / this.poundInPence,
    }
  }
}

export default ItemContainer
